import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, useContext, watch } from "@nuxtjs/composition-api";
import { useMobile } from "~/core/composables/useMobile";
import { ERROR_STATUSES } from "~/core/services/utils/Constants";
import { ACTIONS as USER_FEEDBACK_ACTIONS } from "~/store/affility/user/feedback/modals/full-loader/names";
import { ACTIONS as TOAST_ACTIONS } from "~/store/affility/user/feedback/modals/toast-notification/names";
import ApiService from "~/core/services/api-interaction/ApiService";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignInWithEmail',
  emits: ['onSuccessfullySignIn', 'onForgotPassword', 'onConnectWallet', 'onTwoFactorLogin'],
  setup(__props, { emit: $emit }) {

const nuxt = useContext();
const isMobile = useMobile();
const currentColorMode = nuxt.$colorMode;
const turnstileContainer = ref(null);

const currentColorModeValue = computed(() => {
    return currentColorMode.value || 'light';
})



const signInForm = ref({
    email: '',
    password: '',
    turnstile_response: null,
})
const emailError = ref('');
const passwordError = ref('');
const turnstileError = ref('');
const isSubmitted = ref(false);
const isFormValid = ref(false);
const isFormLoading = ref(false);

const handleChangeTurnstile = (value) => {
    signInForm.value.turnstile_response = value;
}

const openFullScreenPopup = () => {
    nuxt.store.dispatch(
        `affility/user/feedback/modals/full-loader/${USER_FEEDBACK_ACTIONS.OPEN_FULL_PAGE_LOADING}`,
        nuxt.i18n.t('please_wait')
    );
}

const closeFullScreenPopup = () => {
    nuxt.store.dispatch(`affility/user/feedback/modals/full-loader/${USER_FEEDBACK_ACTIONS.CLOSE_FULL_PAGE_LOADING}`);
}

const handleLogin = async () => {
    isSubmitted.value = true;
    handleValidate();

    if (isFormValid.value) {
        isFormLoading.value = true;
        openFullScreenPopup();
        try {
            const response = await ApiService.post('/auth/login-credentials', signInForm.value);

            if (response?.data?.user) {
                await nuxt.$auth.setUserToken(response.data.token);
                $emit('onSuccessfullySignIn', signInForm.value);
            } else {
                $emit('onTwoFactorLogin', {
                    token: response.data.token,
                    email: response.data.email,
                })
            }
        } catch (err) {
            isSubmitted.value = false;
            signInForm.value.turnstile_response = null;
            turnstileContainer.value.reset();
            onError(err);
        } finally {
            setTimeout(() => {
                isFormLoading.value = false;
                closeFullScreenPopup();
            }, 600)
        }
    }
}

const onError = (errorObject) => {
    let errorText = '';

    if(errorObject?.code === ERROR_STATUSES.AUTHORIZATION_ERROR) {
        errorText = "invalid_credentials_please_try_again";
    } else if (errorObject?.code === ERROR_STATUSES.PERMISSION_DENIED) {
        errorText = "too_many_login_attempts_for_this_account_please_try_again_later";
    } else {
        errorText = "an_error_occurred_while_logging_in_please_try_again";
    }
    nuxt.store.dispatch(`affility/user/feedback/modals/toast-notification/${TOAST_ACTIONS.SHOW_ERROR_TOAST}`, {
        description: nuxt.i18n.t(errorText),
    })
}

const handleValidate = () => {
    emailError.value = isSubmitted.value && !signInForm.value.email
        ? 'please_enter_your_email_address_or_username' : '';
    passwordError.value = isSubmitted.value && !signInForm.value.password
        ? 'please_enter_your_password' : '';
    turnstileError.value = isSubmitted.value && !signInForm.value.turnstile_response
        ? 'please_complete_the_security_check_to_proceed' : '';

    isFormValid.value = !emailError.value && !passwordError.value && !turnstileError.value;
}

watch(
    () => signInForm,
    () => {
        handleValidate();
    },
    { deep: true }
);


return { __sfc: true,nuxt, isMobile, currentColorMode, turnstileContainer, currentColorModeValue, $emit, signInForm, emailError, passwordError, turnstileError, isSubmitted, isFormValid, isFormLoading, handleChangeTurnstile, openFullScreenPopup, closeFullScreenPopup, handleLogin, onError, handleValidate }
}

})